import React, { useState } from "react";
import AlertModal from "./AlertModal";
import { SettoriService } from "../services/settoriService";
import { Section } from "../types/section/section";

interface SettoriTabProps {
  competitionId: number;
  sections: Section[];
  setSections: React.Dispatch<React.SetStateAction<Section[]>>;
}

const SettoriTab: React.FC<SettoriTabProps> = ({
  competitionId,
  sections,
  setSections,
}) => {
  const confirmDeleteSettore = async () => {
    if (deleteSettoreId) {
      try {
        await SettoriService.deleteSettore(deleteSettoreId);
        setSections((prev: Section[]) =>
          prev.filter((s: Section) => s.id !== deleteSettoreId)
        );
        setIsDeleteModalOpen(false);
        setDeleteSettoreId(null);
      } catch (err) {
        alert("Errore nell'eliminazione del settore");
      }
    }
  };
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteSettoreId, setDeleteSettoreId] = useState<number | null>(null);
  const handleEditSettoreSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (editSettoreId && editSettoreName.trim()) {
      try {
        await SettoriService.editSettore(editSettoreId, editSettoreName.trim());
        setSections((prev: Section[]) =>
          prev.map((s: Section) =>
            s.id === editSettoreId ? { ...s, name: editSettoreName.trim() } : s
          )
        );
        setIsEditModalOpen(false);
        setEditSettoreId(null);
        setEditSettoreName("");
      } catch (err) {
        alert("Errore nella modifica del settore");
      }
    }
  };
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editSettoreName, setEditSettoreName] = useState("");
  const [editSettoreId, setEditSettoreId] = useState<number | null>(null);
  // Funzione per modificare un settore
  const handleEditSettore = async (section: Section) => {
    setEditSettoreId(section.id);
    setEditSettoreName(section.name);
    setIsEditModalOpen(true);
  };

  // Funzione per eliminare un settore
  const handleDeleteSettore = async (sectionId: number) => {
    setDeleteSettoreId(sectionId);
    setIsDeleteModalOpen(true);
  };
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [settoreName, setSettoreName] = useState("");

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const handleAddSettore = async (e: React.FormEvent) => {
    e.preventDefault();
    if (settoreName.trim()) {
      try {
        const nuovoSettore = await SettoriService.createSettore(
          competitionId,
          settoreName.trim()
        );
        setSections((prev) => [...prev, nuovoSettore]);
        setSettoreName("");
        closeModal();
      } catch (err) {
        alert("Errore nella creazione del settore");
      }
    }
  };

  return (
    <div>
      {/* Modale conferma eliminazione settore */}
      <AlertModal
        isOpen={isDeleteModalOpen}
        message="Sei sicuro di voler eliminare questo settore? Verranno eliminati anche i risultati associati al settore."
        confirmText="Elimina"
        cancelText="Annulla"
        onConfirm={confirmDeleteSettore}
        onCancel={() => {
          setIsDeleteModalOpen(false);
          setDeleteSettoreId(null);
        }}
      />
      {/* Modale modifica settore */}
      {isEditModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
          <div className="bg-white rounded-lg p-6 w-full max-w-md relative">
            <button
              className="absolute top-2 right-2 text-gray-400 hover:text-gray-600"
              onClick={() => {
                setIsEditModalOpen(false);
                setEditSettoreId(null);
                setEditSettoreName("");
              }}
            >
              ×
            </button>
            <h3 className="text-lg font-semibold mb-4">Modifica Settore</h3>
            <form onSubmit={handleEditSettoreSubmit} className="space-y-4">
              <div>
                <label className="block mb-1">Nuovo nome settore</label>
                <input
                  type="text"
                  value={editSettoreName}
                  onChange={(e) => setEditSettoreName(e.target.value)}
                  className="w-full border rounded px-2 py-1"
                  required
                />
              </div>
              <div className="flex justify-end gap-2">
                <button
                  type="button"
                  className="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400"
                  onClick={() => {
                    setIsEditModalOpen(false);
                    setEditSettoreId(null);
                    setEditSettoreName("");
                  }}
                >
                  Annulla
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-brand-600 text-white rounded hover:bg-brand-700"
                >
                  Salva
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      <button
        className="mb-4 px-4 py-2 bg-brand-600 text-white rounded hover:bg-brand-700"
        onClick={openModal}
      >
        Aggiungi Settore
      </button>

      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
          <div className="bg-white rounded-lg p-6 w-full max-w-md relative">
            <button
              className="absolute top-2 right-2 text-gray-400 hover:text-gray-600"
              onClick={closeModal}
            >
              ×
            </button>
            <h3 className="text-lg font-semibold mb-4">Nuovo Settore</h3>
            <form onSubmit={handleAddSettore} className="space-y-4">
              <div>
                <label className="block mb-1">Nome Settore</label>
                <input
                  type="text"
                  value={settoreName}
                  onChange={(e) => setSettoreName(e.target.value)}
                  className="w-full border rounded px-2 py-1"
                  required
                />
              </div>
              <div className="flex justify-end">
                <button
                  type="submit"
                  className="px-4 py-2 bg-brand-600 text-white rounded hover:bg-brand-700"
                >
                  Salva Settore
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      <ul className="mt-4 space-y-2">
        {sections.map((section) => (
          <li
            key={section.id}
            className="border rounded px-3 py-2 bg-gray-50 flex items-center justify-between"
          >
            <span>{section.name}</span>
            <div className="flex gap-2">
              <button
                className="text-brand-500 hover:text-brand-700 font-medium text-sm transition-colors"
                onClick={() => handleEditSettore(section)}
              >
                Modifica
              </button>
              <button
                className="text-red-500 hover:text-red-700 font-medium text-sm transition-colors"
                onClick={() => handleDeleteSettore(section.id)}
              >
                Rimuovi
              </button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SettoriTab;
